import {
  Button,
  Stack,
  TextInput,
} from '@mantine/core'
import { useForm } from '@mantine/form'
import {
  ArrowLeft,
  Mail,
} from 'lucide-react'
import { Link } from 'react-router-dom'

import { validateEmailStructure } from '@common/utils/validation/authValidators'
import { useAuthStore } from '@store/auth.store'
import { AuthShell } from './AuthShell'

interface ForgotPasswordFormValues {
  email: string
}

const getEmailError = (email: string) => {
  if (!email) {
    return 'Email is required'
  }

  return validateEmailStructure(email) ? null : 'Incorrect email format'
}

const ForgotPassword = () => {
  const requestPasswordReset = useAuthStore((state) => state.requestPasswordReset)
  const requestingPasswordReset = useAuthStore((state) => state.requestingPasswordReset)

  const form = useForm<ForgotPasswordFormValues>({
    initialValues: {
      email: '',
    },
    validateInputOnBlur: true,
    transformValues: (values) => ({
      email: values.email.trim(),
    }),
    validate: {
      email: getEmailError,
    },
  })

  const handleSubmit = async (values: ForgotPasswordFormValues) => {
    await requestPasswordReset(values.email)
  }

  return (
    <AuthShell
      title={'Forgot password?'}
      subtitle={'Enter your email and we will send you a password reset link'}
    >
      <form onSubmit={form.onSubmit(handleSubmit)}>
        <Stack gap={'md'}>
          <TextInput
            label={'Email Address'}
            placeholder={'Enter email'}
            type={'email'}
            autoComplete={'email'}
            leftSection={<Mail size={16} />}
            required
            {...form.getInputProps('email')}
          />
          <Button
            type={'submit'}
            loading={requestingPasswordReset}
            disabled={!form.values.email}
          >
            Send Email
          </Button>
          <Button
            component={Link}
            to={'/'}
            variant={'default'}
            leftSection={<ArrowLeft size={16} />}
          >
            Back to Login
          </Button>
        </Stack>
      </form>
    </AuthShell>
  )
}

export default ForgotPassword
